import { render, staticRenderFns } from "./TextareaDialog.vue?vue&type=template&id=dfde67f2&lang=pug&"
import script from "./TextareaDialog.vue?vue&type=script&lang=ts&"
export * from "./TextareaDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports